import React from 'react';
import TimePicker from 'react-time-picker';

import {libraryOverrides, styles} from './WebTimePicker.style.web';

interface WebTimePickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
  style: any;
  disabled: boolean;
}

const WebTimePicker: React.FC<WebTimePickerProps> = ({
  value,
  onChange,
  style,
  disabled,
}) => {
  return (
    <div
      className="web-time-picker-container"
      style={{...styles.container, ...style}}>
      <style>{libraryOverrides}</style>
      <TimePicker
        onChange={onChange}
        value={value}
        disableClock={true}
        clearIcon={null}
        format="h:mm a"
        hourPlaceholder="hh"
        minutePlaceholder="mm"
        disabled={disabled}
      />
    </div>
  );
};

export default WebTimePicker;
